module.exports = __webpack_public_path__ + "media/images/cleaning/cover-desktop@3x-6a2ad140c750d280cf6fefc7f298fe7e.jpg";